module.exports = __webpack_public_path__ + "img/footer.e568a19c.jpg";